<template>
  <ResultList :config="config" />
</template>

<script>
import ResultList from "../../components/ResultList/ResultList.vue";

export default {
  name: "app",
  components: {
    ResultList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
